import React, { useState, useEffect, useRef } from 'react';
import { FiHome } from 'react-icons/fi';
import { clearToken } from '../auth';
import { useMaterial } from '../MaterialContext';

const MATERIAL_LABELS = {
  pvc: 'PVC',
  aluminio: 'Alumínio',
};

const MATERIAL_COLORS = {
  pvc: { background: '#dbeafe', color: '#1d4ed8' },
  aluminio: { background: '#ede9fe', color: '#6d28d9' },
};

const Header = ({ currentPage, setCurrentPage }) => {
  const { materialType, clearMaterial } = useMaterial();
  const [showEstoquesMenu, setShowEstoquesMenu] = useState(false);
  const [showComprasMenu, setShowComprasMenu] = useState(false);
  const [showObrasMenu, setShowObrasMenu] = useState(false);
  const estoquesRef = useRef(null);
  const comprasRef = useRef(null);
  const obrasRef = useRef(null);

  // Fecha o dropdown se clicar fora dele
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (estoquesRef.current && !estoquesRef.current.contains(event.target)) {
        setShowEstoquesMenu(false);
      }
      if (comprasRef.current && !comprasRef.current.contains(event.target)) {
        setShowComprasMenu(false);
      }
      if (obrasRef.current && !obrasRef.current.contains(event.target)) {
        setShowObrasMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getPageTitle = () => {
    switch (currentPage) {
      case 'estoques':
        return 'Estoque Controle';
      case 'listar_arquivos':
        return 'Listar Arquivos';
      case 'importacao':
        return 'Importação';
      case 'obras':
        return 'Estoque Obras';
      case 'listar_obras':
        return 'Listar Obras';
      case 'listar_obras_futuras':
        return 'Listar Obras Futuras';
      case 'obras_futuras':
        return 'Estoque Obras Futuras';
      case 'compras':
        return 'Estoque Compras';
      case 'listar_compras':
        return 'Listar Compras';
      default:
        return 'Estoque Controle';
    }
  };

  const navigate = (page) => {
    setCurrentPage(page);
    setShowEstoquesMenu(false);
    setShowComprasMenu(false);
    setShowObrasMenu(false);
  };

  const handleLogout = () => {
    clearToken();
    try {
      window.dispatchEvent(new CustomEvent('auth:logout'));
    } catch (err) {}
  };

  return (
    <header className="header">
      <div className="nav-menu">
        <div
          className="nav-item dropdown"
          ref={estoquesRef}
          onMouseEnter={() => setShowEstoquesMenu(true)}
          onMouseLeave={() => setShowEstoquesMenu(false)}
        >
          <button
            className={`nav-item ${['estoques', 'listar_arquivos'].includes(currentPage) ? 'active' : ''}`}
            onClick={() => navigate('estoques')}
          >
            Estoques ▾
          </button>
          {showEstoquesMenu && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => navigate('estoques')}>
                Controle Estoque
              </button>
              <button className="dropdown-item" onClick={() => navigate('listar_arquivos')}>
                Listar arquivos
              </button>
            </div>
          )}
        </div>
        <button
          className={`nav-item ${currentPage === 'importacao' ? 'active' : ''}`}
          onClick={() => navigate('importacao')}
        >
          Importação
        </button>
        <div
          className="nav-item dropdown"
          ref={comprasRef}
          onMouseEnter={() => setShowComprasMenu(true)}
          onMouseLeave={() => setShowComprasMenu(false)}
        >
          <button
            className={`nav-item ${['compras', 'listar_compras'].includes(currentPage) ? 'active' : ''}`}
            onClick={() => navigate('compras')}
          >
            Compras ▾
          </button>
          {showComprasMenu && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => navigate('listar_compras')}>
                Listar Compras
              </button>
              <button className="dropdown-item" onClick={() => navigate('compras')}>
                Estoque Compras
              </button>
            </div>
          )}
        </div>

        {/* Dropdown de Obras */}
        <div
          className="nav-item dropdown"
          ref={obrasRef}
          onMouseEnter={() => setShowObrasMenu(true)}
          onMouseLeave={() => setShowObrasMenu(false)}
        >
          <button
            className={`nav-item ${['obras', 'listar_obras', 'listar_obras_futuras', 'obras_futuras'].includes(currentPage) ? 'active' : ''}`}
            onClick={() => navigate('obras')}
          >
            Obras ▾
          </button>
          {showObrasMenu && (
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => navigate('listar_obras')}>
                Listar Obras
              </button>
              <button className="dropdown-item" onClick={() => navigate('listar_obras_futuras')}>
                Listar Obras Futuras
              </button>
              <button className="dropdown-item" onClick={() => navigate('obras')}>
                Estoque Obras
              </button>
              <button className="dropdown-item" onClick={() => navigate('obras_futuras')}>
                Estoque Obras Futuras
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="header-right">
        <div className="breadcrumb">
          <button onClick={() => navigate('estoques')}>
            <FiHome size={16} />
          </button>
          <span> / {getPageTitle()}</span>
        </div>
        {materialType && (
          <span
            style={{
              marginLeft: 16,
              padding: '4px 10px',
              borderRadius: 12,
              fontSize: '0.8rem',
              fontWeight: 600,
              ...MATERIAL_COLORS[materialType],
            }}
          >
            {MATERIAL_LABELS[materialType] || materialType}
          </span>
        )}
        <button
          className="nav-item"
          onClick={clearMaterial}
          style={{ marginLeft: 8, fontSize: '0.85rem' }}
          title="Trocar sistema"
        >
          Trocar
        </button>
        <button className="nav-item" onClick={handleLogout} style={{ marginLeft: 8 }}>
          Sair
        </button>
      </div>

      {/* Estilos simples para o dropdown */}
      <style>
        {`
          .dropdown {
            position: relative;
          }
          .dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            background: #f8f9fa;
            border: 1px solid #e2e8f0;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            min-width: 160px;
            z-index: 100;
          }
          .dropdown-item {
            padding: 8px 12px;
            text-align: left;
            background: transparent;
            border: none;
            cursor: pointer;
          }
          .dropdown-item:hover {
            background-color: #e2e8f0;
          }
        `}
      </style>
    </header>
  );
};

export default Header;
